<div class="sm-console" [class.dark]="isDark">
  <ngx-loading [show]="apiHook.isLoading()"></ngx-loading>

  <!-- ══════════════════════════════════════════════════════════════════════════
       CONSOLE HEADER
  ═══════════════════════════════════════════════════════════════════════════ -->
  <div class="sm-header">
    <div class="sm-header-left">
      <!-- Power LED -->
      <div class="sm-power-led"></div>
      
      <!-- Title Section -->
      <div class="sm-title-section">
        <div class="sm-icon-wrap">
          <fa-icon [icon]="faEnvelope"></fa-icon>
        </div>
        <div class="sm-title-content">
          <span class="sm-eyebrow">MAIL CONSOLE</span>
          <h1 class="sm-title">{{ 'SEND_MAIL.SEND_MAIL' | translate }}</h1>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="sm-header-right">
      <button mat-raised-button class="sm-btn sm-btn--send" (click)="SendMail()">
        <fa-icon [icon]="faPaperPlane" class="sm-btn-icon"></fa-icon>
        <span>{{ 'BUTTON.SEND' | translate }}</span>
      </button>
      <button mat-raised-button class="sm-btn sm-btn--cancel" (click)="onClose($event)">
        <fa-icon [icon]="faTimes" class="sm-btn-icon"></fa-icon>
        <span>{{ 'BUTTON.CANCEL' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════════════════
       RECIPIENTS SECTION
  ═══════════════════════════════════════════════════════════════════════════ -->
  <div class="sm-recipients">
    <div class="sm-section-header">
      <span class="sm-led sm-led--green"></span>
      <span class="sm-led sm-led--yellow"></span>
      <span class="sm-led sm-led--red"></span>
      <span class="sm-section-title">
        <fa-icon [icon]="faUsers" class="me-2"></fa-icon>
        RECIPIENTS
      </span>
      <div class="sm-section-line"></div>
    </div>

    <div class="sm-recipients-field">
      <mat-form-field class="sm-field">
        <mat-select
          multiple
          [formControl]="emaillists"
          [placeholder]="'SEND_MAIL.SELECT_EMAILS_PLACEHOLDER' | translate"
          [(value)]="selectedEmail"
          (selectionChange)="onEmailChange($event)"
          [panelClass]="isDark ? 'sm-panel-dark' : 'sm-panel-light'"
        >
          <mat-option *ngFor="let usermail of usermailIds" [value]="usermail" class="sm-option">
            {{ usermail }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════════════════
       EDITOR SECTION
  ═══════════════════════════════════════════════════════════════════════════ -->
  <div class="sm-editor-section" mat-dialog-content>
    <div class="sm-section-header">
      <span class="sm-led sm-led--green"></span>
      <span class="sm-led sm-led--yellow"></span>
      <span class="sm-led sm-led--red"></span>
      <span class="sm-section-title">
        <fa-icon [icon]="faPen" class="me-2"></fa-icon>
        {{ 'SEND_MAIL.BODY_OF_THE_MAIL' | translate }}
      </span>
      <div class="sm-section-line"></div>
    </div>

    <div class="sm-editor-frame">
      <!-- Scanline Effect -->
      <div class="sm-scanlines"></div>
      
      <!-- Editor Content -->
      <div class="sm-editor-content">
        <quill-editor
          [modules]="quillModules"
          [styles]="{ 'min-height': '300px' }"
          (onEditorCreated)="onQuillEditorCreated($event)"
          [(ngModel)]="editorContent"
          (ngModelChange)="onContentChange()"
          name="email_body"
          class="sm-quill-editor"
        >
        </quill-editor>
        <mat-icon id="input_attach_file_icon" class="sm-attach-icon">attachment</mat-icon>
      </div>
    </div>
  </div>

</div>
